import actionFe from 'utils/mw/actionFe.util';

const feUpdateTimeOffCategories = actionFe('feUpdateTimeOffCategories');

// noinspection JSUnusedGlobalSymbols
export default feUpdateTimeOffCategories;
